// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import config from './config/config'
import http from './http/index'
import Vant from 'vant'
import 'vant/lib/index.css'
import sensorsinit from './config/sensorsinit'

Vue.prototype.$conf = config
Vue.prototype.$http = http
Vue.prototype.$sensors = sensorsinit
Vue.use(ElementUI).use(Vant)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js